module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-floral-6-0b9774b3a7044b01b63ed8744d04436f.webp";